// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3PiHw","left":"styles_left__3MXEL","desktopActions":"styles_desktopActions__3-QkY","title":"styles_title__WiiNp"};